require('./init-global-components')

const hot = require('./hotloading')

const ns = typeof window === 'undefined' ? global : window

ns.HelloBabyApp = hot(module)(
  require('./hello_baby/containers/hello-baby-app').default
)

ns.ProductCollection = hot(module)(
  require('./hello_baby/components/ProductCollection').default
)

ns.ProductSpotlight = hot(module)(
  require('./hello_baby/components/ProductSpotlight').default
)

ns.ReactRailsUJS = require('react_ujs')
